<bid-seacher *ngIf="showHistoricalSearch === true"></bid-seacher>
<div class="bl-wrapper">
  <iframe
    class="bl-iframe"
    src="https://app.powerbi.com/reportEmbed?reportId=8e8bf2fb-1e32-47a1-8190-982516503056&autoAuth=true&ctid=9dfb1a05-5f1d-449a-8960-62abcb479e7d"
    title="Analytics"
    allow="fullscreen"
  ></iframe>
</div>
